// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('customerorder.customerordersearch', {
        url: '/search',
        templateUrl: 'main/customerorder/customerordersearch/customerordersearch.tpl.html',
        controller: 'CustomerOrderSearchController as vm',
        resolve: {
            customerOrder: function() {
                return {};
            }
        },
        params: {
            searchTerm: ''
        }
    });
    $stateProvider.state('customerorder.customerorder', {
        url: '/{orderId}',
        templateUrl: 'main/customerorder/customerordersearch/customerordersearch.tpl.html',
        controller: 'CustomerOrderSearchController as vm',
        resolve: {
            customerOrder: customerOrderResolver
        },
        params: {
            searchTerm: ''
        }
    });
}

// @ngInject
function customerOrderResolver($stateParams, CustomerOrderApiService) {
    return CustomerOrderApiService.getById($stateParams.orderId);
}

// @ngInject
function CustomerOrderSearchController($rootScope, $state, $translate, customerOrder) {
    var vm = this;

    //Properties
    vm.selectedOrder = customerOrder;
    vm.canAccess = $rootScope.canAccess;
    vm.showSearchFields = true;

    //Public methods
    vm.transitionToState = transitionToState;
    vm.toggleSearchFields = toggleSearchFields;
    vm.getStatusTranslation = getStatusTranslation;
    vm.getOrderTypeTranslation = getOrderTypeTranslation;
    vm.showSearchToggle = showSearchToggle;

    activate();

    function activate() {
        vm.showSearchFields = true;
        if (vm.selectedOrder && vm.selectedOrder.id) {
            vm.showSearchFields = false;
        }
    }

    function transitionToState(orderId) {
        $state.go('customerorder.customerorder', { orderId: orderId });
    }

    function toggleSearchFields() {
        vm.showSearchFields = !vm.showSearchFields;
    }

    function showSearchToggle() {
        return vm.selectedOrder && vm.selectedOrder.id;
    }

    function getStatusTranslation(text) {
        var textCapital = text.substr(0, 1).toUpperCase() + text.substr(1, text.length - 1);
        return $translate.instant('customerorder.status' + textCapital);
    }

    function getOrderTypeTranslation(text) {
        var textCapital = text.substr(0, 1).toUpperCase() + text.substr(1, text.length - 1);
        return $translate.instant('customerorder.type' + textCapital);
    }
}

angular
    .module('customerorder.customerordersearch', [])
    .config(stateConfig)
    .controller('CustomerOrderSearchController', CustomerOrderSearchController);
